import React from "react";
import { Icon, ModalDialog } from "@culturehq/components";

import { EventLink } from "app/links";
import { Trans } from "app/utils";

import { Time } from "components/common/Time";
import LazyAddToCalendar from "components/event/view/LazyAddToCalendar";
import ChqModalDialog from "components/common/ChqModalDialog";

const ConfirmedModal = ({ onClose, notification }) => {
  const onClick = () => onClose(notification);
  const { event } = notification.entity;

  return (
    <ChqModalDialog className="event-confirmed" onClose={onClick}>
      <ModalDialog.Body>
        <div className="event-confirmed--icon">
          <Icon icon="ios-checkmark-outline" />
        </div>

        <h2><Trans>YOU ARE CONFIRMED</Trans></h2>

        <EventLink event={event} onClick={onClick} className="event-confirmed--link link" />

        <h3>
          <Trans>on</Trans>
          {" "}
          <Time time={event.startsAt} format="%b %e %Y, %l:%M %p" />
        </h3>

        <LazyAddToCalendar event={event}>
          <Trans>Add to Calendar</Trans>
        </LazyAddToCalendar>
      </ModalDialog.Body>
    </ChqModalDialog>
  );
};

export default ConfirmedModal;
